import { IonSpinner } from '@ionic/react'
import { useImgLoad } from '~/shared/ui/Img/useImgLoad'
import { Image, WrapperLoading } from './styled'

type ImgProps = {
  url?: string
}

export function Img({ url }: ImgProps) {
  const { isLoading, imageUrl } = useImgLoad(url)

  if (isLoading) {
    return (
      <WrapperLoading data-testid='img-loading'>
        <IonSpinner name='bubbles' data-testid='circular-progress' />
      </WrapperLoading>
    )
  }

  return <Image src={imageUrl} alt='img' />
}
